var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyboardDoubleArrowRight = function SvgKeyboardDoubleArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.057 12 5.473 7.4l1.053-1.053L12.18 12l-5.654 5.654L5.473 16.6zm6.35 0-4.584-4.6 1.053-1.053L18.53 12l-5.654 5.654-1.053-1.054z"
  })));
};
export default SvgKeyboardDoubleArrowRight;